const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
          scopes: [process.env.REACT_APP_COGNITO_OAUTH_SCOPES],
          redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN,
          redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT,
          responseType: "code",
        },
      },
      username: true,
    },
  },
};

export default awsconfig;
